<template>
  <div class="empadronamiento__intro__main">
    <div class="empadronamiento__intro__main__form">
      <div
        class="empadronamiento__intro__main__form__container empadronamiento__success"
      >
        <h2
          class="empadronamiento__success__title"
          style="font-size: 20px!important;"
        >
          TRÁMITE REGISTRADO CORRECTAMENTE
        </h2>
        <p style="text-align: justify;padding: 0 25px;">
          Muchas gracias por completar la información.<br /><br />
          Tu trámite se registró correctamente, y comenzará el período de
          revisión por AVN. <br /><br />
          Cuando el mismo finalice, se te notificará el estado del trámite.<br /><br />
          <b
            >Te recordamos que se podrán realizar mudanzas una vez que se
            complete el proceso.</b
          >
        </p>
        <p style="text-align: justify;padding: 0 25px;">
          Para futuras referencias el código del trámite es:
          <strong>{{ ModelProcedure.ProcedureCode }}</strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      ModelProcedure: (state) => state.manageVecino.ModelProcedure,
    }),
  },
  mounted() {
    const popHandler = () => {
      window.history.forward();
      setTimeout(() => {
        window.addEventListener("popstate", popHandler, { once: true });
      }, 50); // delay needed since the above is an async operation for some reason
    };
    window.addEventListener("popstate", popHandler, { once: true });
    window.history.pushState(null, null, null);
    const self = this;
    if (!this.ModelProcedure.hasOwnProperty("UCode")) {
      this.$store.dispatch("getProcedure", {
        ucode: self.$route.query.ucode,
      });
    }
  },
};
</script>

<style></style>
